export const marketplaceOnboardingHandler = {
    pathPattern: '/brands/:brandId/home',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}/home` }),
    meta: {
        title: 'Marketplace onboarding',
        description: 'Opens brand home with a marketplace onboarding settings panel (via ?settings=).',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'settings', in: 'query', required: true },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId' },
            query: { settings: 'brand.marketplaces.grubhub' },
        },
    },
};
//# sourceMappingURL=marketplace-onboarding.js.map